import React from 'react';
import { Modal } from 'antd';
import './modalpopup.scss';
const ModalPopupComponent = ({
    title = '',
    visible,
    hideModal = () => {},
    footer,
    className = 'darkTheme',
    onOk = () => {},
    width = 800, // default value if the width is not specified-
    maskClosable = false, // Closes the modal if user clicks off the modal-
    closable = true, // Show the 'X' in the upper right corner of the header-
    ...props
}) => {
    return (
        <div>
            <Modal
                title={title}
                open={visible}
                width={width}
                closable={closable}
                onCancel={hideModal}
                footer={footer}
                maskClosable={maskClosable}
                centered
                className={'darkTheme ' + className}
                onOk={onOk}
            >
                {props?.children}
            </Modal>          
        </div>
    );
};

export default ModalPopupComponent;
